import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/i18n/content";

const LanguageContext = createContext(null);

const SUPPORTED = ["en", "fr", "ar"];

function detectLanguage() {
  const stored = localStorage.getItem("azt_lang");
  if (stored && SUPPORTED.includes(stored)) return stored;

  // Auto-detect from browser languages (EU visitors -> fr where applicable)
  const langs = navigator.languages || [navigator.language || "en"];
  for (const l of langs) {
    const code = l.toLowerCase().slice(0, 2);
    if (SUPPORTED.includes(code)) return code;
  }
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    setLangState(detectLanguage());
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("azt_lang", l);
    setLangState(l);
  };

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] || translations.en }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
